/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForCostAnomalyDetectorForResources extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForCostAnomalyDetectorForResources");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForCostAnomalyDetectorForResources.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForCostAnomalyDetectorForResources>): BackgroundJobPayloadForCostAnomalyDetectorForResources {
        let obj = Object.assign(new BackgroundJobPayloadForCostAnomalyDetectorForResources(), model);
        BackgroundJobPayloadForCostAnomalyDetectorForResources.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForCostAnomalyDetectorForResources>): BackgroundJobPayloadForCostAnomalyDetectorForResources {
        if (!model) return null;
        return BackgroundJobPayloadForCostAnomalyDetectorForResources.newInstance(<BackgroundJobPayloadForCostAnomalyDetectorForResources> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForCostAnomalyDetectorForResources) {
        if (!obj) return;

        models.BackgroundJobPayloadForCostAnomalyDetectorForResources.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForCostAnomalyDetectorForResources): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForCostAnomalyDetectorForResources.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID
     */
    service_account_id: string;

}
